import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import Cookies from "js-cookie";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { isAuthenticated, loading } = useContext(AuthContext);
  const userDets = Cookies.get("userDets");
  let userRole;

  try {
    userRole = userDets != undefined ? JSON.parse(userDets).role : null;
  } catch (error) {
    console.error("Error parsing userDets cookie:", error);
    userRole = null;
  }

  if (loading) {
    // Show a placeholder while checking authentication
    return <div>Loading...</div>;
  }

  if (!isAuthenticated || !userRole) {
    return <Navigate to="/login" />;
  }

  if (isAuthenticated && (!userRole || !allowedRoles.includes(userRole))) {
    return <Navigate to="/not-authorized" />;
  }

  return children;

};

export default ProtectedRoute;
